import { render, staticRenderFns } from "./DownloadWarning.vue?vue&type=template&id=ad25d23c&scoped=true&"
import script from "./DownloadWarning.vue?vue&type=script&lang=js&"
export * from "./DownloadWarning.vue?vue&type=script&lang=js&"
import style0 from "./DownloadWarning.vue?vue&type=style&index=0&id=ad25d23c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad25d23c",
  null
  
)

export default component.exports